/**
*
* Button
*
*/

// import React from 'react';
import styled, { css } from 'styled-components';

const Button = styled.button`
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 12px 24px;
  line-height: normal;
  height: auto;
  outline: 0;
  border: none;
  vertical-align: baseline;
  background: #e0e1e2 none;
  color: rgba(0,0,0,.6);
  margin: 0 .25em 0 0;
  text-transform: none;
  text-shadow: none;
  font-weight: 700;
  font-style: normal;
  text-align: center;
  text-decoration: none;
  border-radius:5px;
  a{
    color: ${({ theme }) => theme.whiteColor};
    text-decoration:none;
  }
  ${({ fontSize }) => fontSize && css`font-size: ${fontSize || '16px'};`}
  ${({ color }) => color && css`background-color:red;`}
  ${({ type }) => {
    if (type === 'primary') {
      return css`
        background-color: ${(props) => props.theme.primaryColor};
        color: ${({ theme }) => theme.lightWhite};
      `;
    }
    if (type === 'secondary') {
      return css`
        background-color: ${(props) => props.theme.secondaryColor};
        color: ${({ theme }) => theme.whiteColor};
      `;
    }
    return '';
  }}
`; // eslint-disable-line indent
Button.displayName = 'button';

export default Button;



// WEBPACK FOOTER //
// client/components/Button/index.js